import { useQuery } from '@tanstack/react-query';
import { getAssessments } from 'api/assessments';
import { assessmentsKeys } from 'api/queryKeys';
import { useMainCompanyQuery } from './useMainCompanyQuery';

export const useAssessmentsQuery = (
  filters: { area_ids?: number[] },
  options?: { enabled?: boolean }
) => {
  const { data: mainCompany } = useMainCompanyQuery();
  const companyId = mainCompany?.id ?? '';

  return useQuery({
    queryKey: assessmentsKeys.list(companyId, filters),
    queryFn: () => getAssessments({ filters }).then((res) => res.data),
    enabled: !!companyId && (options?.enabled ?? true)
  });
};
